import { jsxs, jsx } from "react/jsx-runtime";
import { Image as Image$1, Box } from "@zillow/constellation";
import { withPreload, prefixSpacingTokens } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import React from "react";
import { usePlacement } from "../../components/PlacementProvider/PlacementProvider.esm.js";
import StructuredData from "../../components/StructuredData/StructuredData.esm.js";
import { withAnchor } from "../../util/helpers.esm.js";
import BlockParagraph from "../Paragraph/Paragraph.esm.js";
const ImagePreload = withPreload(Image$1);
const BlockImage = ({
  attrs,
  index
}) => {
  const {
    alt,
    caption,
    src,
    width,
    height,
    loading = "lazy",
    decoding = "async",
    sizes,
    srcSet,
    margin
  } = attrs;
  const structuredData = {
    "@context": "https://schema.org/",
    "@type": "ImageObject",
    contentUrl: src,
    caption: alt,
    height,
    width
  };
  const isPost = usePlacement() === "post";
  return /* @__PURE__ */ jsxs(React.Fragment, { children: [
    /* @__PURE__ */ jsx(StructuredData, { data: structuredData }),
    /* @__PURE__ */ jsxs(Box, { as: "figure", sx: {
      // By default <figure> has these default margins
      margin: 0,
      lineHeight: 0,
      ...isPost ? {
        marginBottom: "$spacing.md"
      } : prefixSpacingTokens(margin)
    }, children: [
      /* @__PURE__ */ jsx(
        ImagePreload,
        {
          src,
          alt,
          width,
          height,
          loading,
          decoding,
          srcSet,
          sizes
        },
        index
      ),
      caption && /* @__PURE__ */ jsx(BlockParagraph, { attrs: {
        as: "figcaption",
        fontColor: "coolGray500",
        fontType: "bodySmall",
        content: caption,
        textAlign: "center",
        margin: {
          marginTop: "xs",
          marginBottom: "none"
        }
      } })
    ] })
  ] });
};
BlockImage.propTypes = {
  attrs: PropTypes.shape({
    alt: PropTypes.string,
    caption: PropTypes.string,
    src: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    loading: PropTypes.string
  }),
  index: PropTypes.number
};
const Image = withAnchor(BlockImage);
export {
  Image as default
};
